<template>
    <Button
        v-if="isMobile"
        @click="$emit('click')"
        class="btn-show-more"
    >
        Показать еще
    </Button>
    <span
        v-else
        @click="$emit('click')"
        class="link-show-more"
    >
        Показать еще
    </span>
</template>

<script>
import Button from '../../../../UI/Button';

import {mapGetters} from 'vuex';

const getters = [
    'isMobile',
];

export default {
    name: 'ShowMoreButton',
    components: {
        Button,
    },
    computed: {
        ...mapGetters(getters),
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';

    .btn-show-more {
        border-radius: mrem(4);
        width: 100%;
    }
    .link-show-more {
        cursor: pointer;
        display: inline-block;
        font-style: normal;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #4663AB;
        padding-bottom: 1px;
        border-bottom: 1px solid #4663AB;
        margin-top: rem(24);
    }
</style>